//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ApplicationClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> },
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? "";
  }

  verifySignupCode(code: string | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/Application/verify?";
    if (code === null)
      throw new globalThis.Error("The parameter 'code' cannot be null.");
    else if (code !== undefined)
      url_ += "code=" + encodeURIComponent("" + code) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processVerifySignupCode(_response);
    });
  }

  protected processVerifySignupCode(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver,
              ) as ProblemDetails);
        return throwException(
          "Bad Request",
          status,
          _responseText,
          _headers,
          result400,
        );
      });
    } else if (status === 429) {
      return response.text().then((_responseText) => {
        let result429: any = null;
        result429 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver,
              ) as ProblemDetails);
        return throwException(
          "Too Many Requests",
          status,
          _responseText,
          _headers,
          result429,
        );
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver,
              ) as ProblemDetails);
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers,
          result500,
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  confirmApplication(verificationCode: string | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/Application/confirm?";
    if (verificationCode === null)
      throw new globalThis.Error(
        "The parameter 'verificationCode' cannot be null.",
      );
    else if (verificationCode !== undefined)
      url_ +=
        "verificationCode=" + encodeURIComponent("" + verificationCode) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processConfirmApplication(_response);
    });
  }

  protected processConfirmApplication(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver,
              ) as ProblemDetails);
        return throwException(
          "Bad Request",
          status,
          _responseText,
          _headers,
          result400,
        );
      });
    } else if (status === 429) {
      return response.text().then((_responseText) => {
        let result429: any = null;
        result429 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver,
              ) as ProblemDetails);
        return throwException(
          "Too Many Requests",
          status,
          _responseText,
          _headers,
          result429,
        );
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver,
              ) as ProblemDetails);
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers,
          result500,
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  submitApplication(body: ApplicationData | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/Application/apply";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSubmitApplication(_response);
    });
  }

  protected processSubmitApplication(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver,
              ) as ProblemDetails);
        return throwException(
          "Bad Request",
          status,
          _responseText,
          _headers,
          result400,
        );
      });
    } else if (status === 429) {
      return response.text().then((_responseText) => {
        let result429: any = null;
        result429 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver,
              ) as ProblemDetails);
        return throwException(
          "Too Many Requests",
          status,
          _responseText,
          _headers,
          result429,
        );
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver,
              ) as ProblemDetails);
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers,
          result500,
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export class FormsClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> },
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? "";
  }

  getSchemas(): Promise<void> {
    let url_ = this.baseUrl + "/api/Forms/Schemas";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetSchemas(_response);
    });
  }

  protected processGetSchemas(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver,
              ) as ProblemDetails);
        return throwException(
          "Bad Request",
          status,
          _responseText,
          _headers,
          result400,
        );
      });
    } else if (status === 429) {
      return response.text().then((_responseText) => {
        let result429: any = null;
        result429 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver,
              ) as ProblemDetails);
        return throwException(
          "Too Many Requests",
          status,
          _responseText,
          _headers,
          result429,
        );
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver,
              ) as ProblemDetails);
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers,
          result500,
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  getForms(): Promise<void> {
    let url_ = this.baseUrl + "/api/Forms/Forms";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetForms(_response);
    });
  }

  protected processGetForms(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver,
              ) as ProblemDetails);
        return throwException(
          "Bad Request",
          status,
          _responseText,
          _headers,
          result400,
        );
      });
    } else if (status === 429) {
      return response.text().then((_responseText) => {
        let result429: any = null;
        result429 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver,
              ) as ProblemDetails);
        return throwException(
          "Too Many Requests",
          status,
          _responseText,
          _headers,
          result429,
        );
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver,
              ) as ProblemDetails);
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers,
          result500,
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  getControlDefinition(id: string): Promise<void> {
    let url_ = this.baseUrl + "/api/Forms/ControlDefinition/{id}";
    if (id === undefined || id === null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetControlDefinition(_response);
    });
  }

  protected processGetControlDefinition(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver,
              ) as ProblemDetails);
        return throwException(
          "Bad Request",
          status,
          _responseText,
          _headers,
          result400,
        );
      });
    } else if (status === 429) {
      return response.text().then((_responseText) => {
        let result429: any = null;
        result429 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver,
              ) as ProblemDetails);
        return throwException(
          "Too Many Requests",
          status,
          _responseText,
          _headers,
          result429,
        );
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver,
              ) as ProblemDetails);
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers,
          result500,
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  editControlDefinition(id: string, body: any | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/Forms/ControlDefinition/{id}";
    if (id === undefined || id === null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processEditControlDefinition(_response);
    });
  }

  protected processEditControlDefinition(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver,
              ) as ProblemDetails);
        return throwException(
          "Bad Request",
          status,
          _responseText,
          _headers,
          result400,
        );
      });
    } else if (status === 429) {
      return response.text().then((_responseText) => {
        let result429: any = null;
        result429 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver,
              ) as ProblemDetails);
        return throwException(
          "Too Many Requests",
          status,
          _responseText,
          _headers,
          result429,
        );
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver,
              ) as ProblemDetails);
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers,
          result500,
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export interface ApplicationData {
  code: string;
  form: ApplicationForm;
}

export interface ApplicationForm {
  name: string;
  dateOfBirth: string;
  occupation: string;
  email: string;
  mobile: string;
  nominator: string;
  nominatorSignature: string[];
  seconder: string;
  seconderSignature: string[];
}

export interface ProblemDetails {
  type: string | null;
  title: string | null;
  status: number | null;
  detail: string | null;
  instance: string | null;

  [key: string]: any;
}

export interface HttpValidationProblemDetails extends ProblemDetails {
  errors: { [key: string]: string[] };

  [key: string]: any;
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any,
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any,
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}
